import { render, staticRenderFns } from "./Screen-App.vue?vue&type=template&id=0f3019e4&"
import script from "./Screen-App.vue?vue&type=script&lang=js&"
export * from "./Screen-App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports